const jsPdf = import('jspdf').then(module=>module.default);
export default jsPdf;

